// extracted by mini-css-extract-plugin
export default {"Languages":"Languages_Languages__wYV6Q","Icon":"Languages_Icon__K5dKq","CurrentLanguage":"Languages_CurrentLanguage__MfTvK","Active":"Languages_Active__dJ7E-"};